import {makeResource} from 'app/infrastructure/repository'
import { Provider } from './_models';

const PROVIDER_ENDPOINT = 'providers';

export default makeResource<Provider>(PROVIDER_ENDPOINT);

